<template>
    <div>
        <div class="card shadow bg-white">
            <div class="card-header h6">
                Carte de la journée
            </div>
            <div class="p-3 row align-items-center">
                <div class="col-auto">
                    <input class="form-control" type="date" :max="today" v-model="pickedDate" required>
                </div>
                <div class="col-auto">
                    <ButtonDisplay :type="'save'" :text="'Afficher'"
                        @click="this.$router.push({ name: 'DailyHistoryMap', params: { baliseId: balise.id }, query: { date: pickedDate } });" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'

export default {
    props: ['balise'],
    components: {
        ButtonDisplay
    },
    data() {
        return {
            selectedDate: null,
            today: new Date().toISOString().split('T')[0]
        }
    },
}
</script>